import { MonitoredValue } from '../model/monitored-value.enum';

export const isPlayerState = (field: string): boolean => {
  const regex = new RegExp(`^${MonitoredValue.PlayerState}[_0-9]*$`);
  return !!field.match(regex);
};

/** percent value validation */
export const percentValidation = (value: number): number => value >= 0 ? (value > 100 ? 100 : value) : 0;
